module.exports = __webpack_public_path__ + "static/media/Engpic1@3x.12bf509a.png";